<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [addText]="'Add New'"
                            [customAddText]="'Select'"
                            [customDeleteText]="'Remove'"
                            [customActionComponent]="this"
                            [showEdit]="true"
                            [showDelete]="false"
                        ></action-toolbar-buttons>
                        @if (canEdit) {
                            <button
                                type="button"
                                class="btn btn-sm btn-secondary ml-2"
                                (click)="showCopyFromMeetingModal()"
                                title="Add all metrics from another meeting"
                            >
                                Copy from Meeting
                            </button>
                        }
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export #gridExport [grid]="mainGrid" [name]="'Goals'" [showButton]="false"></grid-export>
                        <button
                            type="button"
                            style="margin-left: -5px"
                            class="btn btn-sm btn-secondary"
                            (click)="showExportModal()"
                            title="Export to Excel"
                        >
                            Export
                        </button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        [padding]="73"
                        [minHeight]="200"
                        (initialized)="grid.initialize(mainGrid)"
                        [itemFormatter]="goalsGridItemFormatter"
                        (destroy)="grid.destroy()"
                        [itemsSource]="grid.view"
                        (beginningEdit)="beginningEdit(mainGrid, $event)"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Who'" [binding]="'userId'" [dataMap]="allUserMap" [width]="75" [isReadOnly]="true">
                        </wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Metric'" [binding]="'name'" [width]="300" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="' '"
                            [binding]="'goalDirection'"
                            [dataMap]="goalDirectionMap"
                            [width]="70"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Goal'"
                            [binding]="'goal1'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Average'"
                            [binding]="'average'"
                            [width]="100"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sum'"
                            [binding]="'sum'"
                            [width]="120"
                            [align]="'center'"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        @for (month of weekCols; track month) {
                            <wj-flex-grid-column
                                [binding]="'weekValues.' + month"
                                [align]="'center'"
                                [header]="month"
                                [width]="100"
                                [isRequired]="false"
                            >
                            </wj-flex-grid-column>
                        }
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
